import Deprecated from '../../core/Deprecated';
import { withRouter } from 'react-router-dom';
import { APPLICATION_PATHS } from '../../application-core/constants';
import SchemeLink from '../core/SchemeLink';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import XL from '../core/XL';
import SearchDropDown from '../../core/SearchDropDown';
import { Typography } from '@material-ui/core';
import GS from '../../grafsync/grafsync';

class ProjectConceptSearch extends Component {

  onFoundConcept = (id, result) => {
    if (result.inScheme) {
      // Find the first loaded scheme
      const foundScheme = result.inScheme.find(scheme => GS.isLoaded(scheme, this.props.graph));
      if (foundScheme) {
        let link = APPLICATION_PATHS.TAXONOMY_MANAGER + '/project/taxonomy#project='
          + this.props.project
          + "&taxonomy=" + foundScheme
          + "&view=concept"
          + "&concept=" + id;
        this.props.history.push(link);
      }
    }
  };

  render() {

    const { skosXL, defaultLang, graph } = this.props;

    return (
      <div style={{ height: 40, maxWidth: 400, marginRight: 12, marginBottom: 12, overflow: 'visible' }}>
        <SearchDropDown
          dataTest="find-concept"
          focus={true}
          search={(value, lang) => {
            return {
              search: [{
                predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                value: ["http://www.w3.org/2004/02/skos/core#Concept"]
              },
              {
                predicate: "http://www.w3.org/2004/02/skos/core#inScheme"
              },
              {
                predicate: ["http://www.w3.org/2004/02/skos/core#prefLabel", "http://www.w3.org/2004/02/skos/core#altLabel"],
                value: value,
                isExactMatch: false
              }],
              graph: [graph],
              language: lang,
              entailment: skosXL ? ["propertyChain"] : [],
              predicates: [
                "http://www.w3.org/2004/02/skos/core#prefLabel",
                "http://www.w3.org/2002/07/owl#deprecated",
                "http://www.w3.org/2004/02/skos/core#inScheme"]
            };
          }}
          sortProp="prefLabel"
          suppressMessages={true}
          listSecondIcon={(result) => {
            if (result.deprecated) return <Deprecated />;
            if (result.isEntailed) return <XL />;
            return null;
          }}
          listDisplay={(result, lang) => <div>
            <div data-test="result-label">
              <Typography variant="body2">
                <span style={{ wordBreak: 'break-word' }}>
                  {result.prefLabel[lang] ?
                    result.prefLabel[lang]
                    :
                    result.id
                  }
                </span>
              </Typography>
            </div>
            {result.inScheme &&
              <div>
                {result.inScheme.map((scheme, index) => {
                  if (index < 2 || (index < 3 && result.inScheme.length === 3)) {
                    return <SchemeLink key={scheme} id={scheme} handleNotAvailable={true} graph={graph} defaultLang={defaultLang} />;
                  }
                  else return null;
                })}
                {result.inScheme.length > 3 &&
                  <Typography
                    data-test="too-many-schemes"
                    variant="caption"
                    style={{ marginLeft: 20, marginTop: 4 }}>Additional schemes were also found ({result.inScheme.length - 2}).</Typography>
                }
              </div>
            }
          </div>}
          listSelectionDisplay={(result, lang) => {
            if (result.prefLabel && result.prefLabel[lang]) {
              return result.prefLabel[lang];
            }
            else return result.id;
          }}
          title="Find a project concept"
          lang={defaultLang}
          chosen={this.onFoundConcept} />
      </div>
    );
  }

}

ProjectConceptSearch.propTypes = {
  project: PropTypes.string.isRequired,
  history: PropTypes.object,
  skosXL: PropTypes.bool.isRequired,
  graph: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired
};

export default withRouter(ProjectConceptSearch);